export default __webpack_public_path__ + "static/media/soundcloud.2610be8c.svg";